import React from "react";

import classNames from "classnames";
import { Sun, Moon } from "@boxicons/react";

export default function ThemeSwitchButton({
  onClick,
  darkThemeIsActive,
  size = "md",
}) {
  const btnClassName = classNames("theme-switch-btn", size, {
    "active": darkThemeIsActive,
  });
  const Icon = darkThemeIsActive ? Sun : Moon;

  return (
    <button
      type="button"
      className={btnClassName}
      onClick={onClick}
      title="Theme"
    >
      <Icon width={28} height={28} />
    </button>
  );
}
